import { NavLink } from '@mantine/core';
import { ReactNode } from 'react';
import { useLocation, useRoute } from 'wouter';

import { useAdminNav } from '@/features/admin/contexts/AdminNavContext';

interface SidebarNavLinkProps {
	href: string;
	label: string;
	icon: ReactNode;
}

export default function SidebarNavLink({
	href,
	label,
	icon,
}: SidebarNavLinkProps) {
	const [isActive] = useRoute(href);
	const [, setLocation] = useLocation();
	const { closeMobileNav } = useAdminNav();

	const handleClick = () => {
		setLocation(href);
		closeMobileNav();
	};

	return (
		<NavLink
			label={label}
			leftSection={icon}
			active={isActive}
			onClick={handleClick}
		/>
	);
}
